import React from 'react';
import RequestsList from 'components/requestsList/RequestsList';

const Requests = () => {
    return (
        <RequestsList title="All Accounts"/>
    )
}

export default Requests